import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ImInfo } from 'react-icons/im';
import { log } from 'utils';

import ChartMarketKNMuaRongByNganh from '../chart/chartMarketKNMuaRongByNganh';
import ChartMarketNganhAnhHuong from '../chart/chartMarketNganhAnhHuong';
import { connect } from 'react-redux';
import * as _ from 'lodash'

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function TabNganh(props) {
  const [topAnhHuong, setTopAnhHuong] = React.useState(null);
  const [thanhKhoan, setThanhKhoan] = React.useState(null);
  const [tangGiam, setTangGiam] = React.useState(null);
  const [vonHoa, setVonHoa] = React.useState(null);
  const [intervalId, setIntervalId] = React.useState(null);

  const { marketActive, typeOrder, t, theme, algoCache } = props;

  const preAlgoCache = usePrevious(algoCache)

  const abortController = new AbortController();

  React.useEffect(() => {
    return () => {
      abortController.abort();
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  React.useEffect(() => {
    if(algoCache && !_.isEqual(algoCache, preAlgoCache)){
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'IND_CONTRIB_RETURN' ){
        setTopAnhHuong(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'IND_PI_TRADING' ){
        setThanhKhoan(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'IND_F_TRADING' ){
        setTangGiam(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'IND_TOTAL_VALUE' ){
        setVonHoa(algoCache?.DATA)
      }
    }
  }, [algoCache])

  React.useEffect(() => {
    let _intervalId;
    if (marketActive) {
      if (intervalId) clearInterval(intervalId);
      loadNganhAnhHuongIndex();
      loadTuDoanhMuaRongTheoNghanh();
      loadKhoiNgoaiMuaRongTheoNganh();
      loadGiaTriGDTheoNganh();

      // _intervalId = setInterval(() => {
      //   loadNganhAnhHuongIndex();
      //   loadTuDoanhMuaRongTheoNghanh();
      //   loadKhoiNgoaiMuaRongTheoNganh();
      //   loadGiaTriGDTheoNganh();
      // }, 10 * 1000);

      // setIntervalId(_intervalId);
    }

    return () => {
      if (_intervalId) clearInterval(_intervalId);
    };
  }, [marketActive]);

  function loadNganhAnhHuongIndex() {
    fetch(appUrl + 'pbapi/api/IndContrib?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setTopAnhHuong(res);
      })
      .catch((error) => {
        log(error);
      });
  }

  function loadTuDoanhMuaRongTheoNghanh() {
    fetch(appUrl + 'pbapi/api/IndPIvalue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setThanhKhoan(res.data);
      })
      .catch((error) => {
        log(error);
      });
  }

  function loadKhoiNgoaiMuaRongTheoNganh() {
    fetch(appUrl + 'pbapi/api/IndFvalue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setTangGiam(res);
      })
      .catch((error) => {
        log(error);
      });
  }

  function loadGiaTriGDTheoNganh() {
    fetch(appUrl + 'pbapi/api/IndTotalValue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setVonHoa(res);
      })
      .catch((error) => {
        log(error);
      });
  }

  return (
    <div
      className="d-grid w-100 h-100"
      style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '15px' }}
    >
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-industry-contrib-index')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.top-nganh-index')} {topAnhHuong?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketNganhAnhHuong topAnhHuong={topAnhHuong} t={t} theme={theme}/>
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Foreigner-trading-by-industries')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.kn-mua-rong-theo-nganh')} {tangGiam?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketKNMuaRongByNganh
            tangGiam={tangGiam}
            typeOrder={typeOrder}
            t={t}
            afterFix={'triệu'}
          />
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Proprietary-trading-by-industries')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.td-mua-rong-theo-nganh')} {thanhKhoan?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketKNMuaRongByNganh
            tangGiam={thanhKhoan}
            typeOrder={typeOrder}
            t={t}
            afterFix={'triệu'}
          />
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Trading-value-by-industries')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.gt-gd-theo-nganh')} {vonHoa?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketKNMuaRongByNganh
            tangGiam={vonHoa}
            typeOrder={typeOrder}
            t={t}
            afterFix={'triệu'}
          />
          {/* <ChartMarketNganhGiaTriGD vonHoa={vonHoa} typeOrder={typeOrder}/> */}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    algoCache: state.socket.algoCache,
  }
}

export default connect(mapStateToProps)(TabNganh)
